export const routeLoaders = {
  '/pages/propostas': () => import('../Propostas/index'),
  '/pages/inicio': () => import('../Home/index'),
  '/pages/contas-pendentes': () => import('../VerificarContas/ContasPendentes/index'),
  '/pages/contas-aprovadas': () => import('../VerificarContas/ContasAprovadas/index'),
  '/pages/contas-rejeitadas': () => import('../VerificarContas/ContasRejeitadas/index'),
  '/pages/clientes': () => import('../Clientes/index'),
  '/pages/freelancers': () => import('../Freelancers/index'),
  '/pages/lancar-atividade': () => import('../FreelancersAtividades/index'),
  '/pages/minhas-atividades': () => import('../FreelancersAtividadesAtivas/index'),
  '/pages/minhas-atividades-freelancer': () => import('../FreelancerMinhasAtividades/index'),
  '/pages/metricas-freelancer': () => import('../FreelancerMetricas/index'),
  '/pages/lancar-em-lote': () => import('../FreelancersAtividadesLote/index'),
  '/pages/2fa': () => import('../2FA/index'),
  '/pages/criar-usuario': () => import('../Users/CreateUser/index'),
  '/pages/cadastro-freelancer': () => import('../Users/CreateFreelancer/index'),
  '/pages/lista-de-usuarios': () => import('../Users/ListUsers/index'),
  '/pages/perfil': () => import('../Profile/index'),
  '/pages/relatorios': () => import('../Reports/Reports'),
  '/pages/form-padrao': () => import('../Forms/FormPadrao'),
  '/pages/time-de-suporte': () => import('../SupportTeam/index'),
};

export const preloadRoute = (route) => {
  const loadRoute = routeLoaders[route];

  if (loadRoute) {
    loadRoute();
  }
};
